import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (typeof window !== 'undefined' && localStorage) {
      const currentToken = localStorage.getItem('access_token');
      if (currentToken) {
        if (state.url === '/login') {
          this.router.navigate(['/dashboard']);
          return false;
        }
        return true;
      } else {
        if (state.url === '/login') {
          return true;
        }
        this.router.navigate(['/login']);
        return false;
      }
    }
    return false;
  }
}
